module.exports = __webpack_public_path__ + "static/media/snake.9d797d5e.svg";